import { withAsyncLoading } from '../../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadableFormationDetailsVideoPage = withAsyncLoading(async () => import('./FormationDetailsVideoPage').then((res) => res.FormationDetailsVideoPage));

export { LoadableFormationDetailsVideoPage };
